
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/cms-complaint",
      function () {
        return require("private-next-pages/products/cms-complaint.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/cms-complaint"])
      });
    }
  